
import Lightbox from "./components/common/Lightbox";

new Lightbox();

// Main Menu
import "./custom/yir/2020/mainMenu";

// Page 3 Maps
import "./custom/yir/2020/page3";
import "./custom/yir/2020/page7";
import "./custom/yir/2020/page9";


